(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["base-cart-add"] && !Shopify.designMode) return;
  try {
    // Add-to-cart without leaving the page. Bundles the drawer section (via the
  // theme's cart:prepare-bundled-sections) and the cart page section when present, then fires the
  // same variant:add / cart:change pair as the theme's product-form so the drawer, <cart-count> and
  // the cart page (main-cart-2026 onCartChanged) all re-render in place.
  window.cartAjaxAdd = async function (form) {
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const cartSection = document.querySelector('[data-cart-items]')?.closest('.shopify-section');
      if (cartSection) sections.push(cartSection.id.replace('shopify-section-', ''));

      const formData = new FormData(form);
      formData.set('sections', sections.join(','));
      formData.set('sections_url', `${Shopify.routes.root}variants/${formData.get('id')}`);
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const responseJson = await response.json();
      if (!response.ok) {
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cart.sections = responseJson.sections;
      form.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: responseJson.items ?? [responseJson],
          cart,
          // On the cart page the line appears in place; don't also slide the drawer open.
          blockCartDrawerOpening: Boolean(cartSection),
        },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart },
      }));
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  } catch(e) { console.error(e); }
})();

})();
